import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { SalesReturnPopup } from './SalesReturnTable';
import moment from 'moment';
import { decryptAES } from '../../../utils/Encryption';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { permission } from '../../../utils/enums/ValidationMessage';
import { Navigate } from 'react-router-dom';

export default class SalesReturn extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isShown: false,
            isSelectItemPopUp: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            urlId: 0,
            salesObject: {
                idSalesReturn: 0,
                returnNo: '',
                returnDate: '',
                updateStatus: 0,
                authorizedBy: 0,
                EmployeeList: [],
                accountHeadList: [],
                idGeneralProduct: 0,
                idReturn: 1,
                returnList: [
                    { value: 1, label: 'MANUALLY' },
                    { value: 2, label: 'FROM SALES' },
                ],
                idGatePass: 0,
                gatepassList: [],
                idCustomer: 0,
                customerList: [],
                idSalesInvoice: 0,
                salesList: [],
                idInv: 1,
                invList: [
                    { value: 1, label: 'INTRASTATE' },
                    { value: 2, label: 'INTERSTATE' },
                ],
                billNo: '',
                billDate: '',
                totalQty: '',
                totalAmt: '',
                extraCharges: '',
                totalDiscountAmt: '',
                taxAmt: '',
                totalTax: '',
                finalAmt: '',
                totalwithTax: '',
                taxableAmt: '',
                adjustableAmt: '',
            },
            itemObject: {
                drawingNo: '',
                idType: 1,
                TypeList: [
                    { value: 1, label: "RAW MATERIAL" },
                    { value: 2, label: "FINISHED GOODS" },
                    { value: 3, label: "SEMI FINISHED" },
                    { value: 4, label: "SCRAP MATERIAL" },
                ],
                idItem: 0,
                itemList: [],
                idUnit: 0,
                unitList: [],
                returnQuantity: '',
                quantity: '',
                rate: '',
                amount: '',
                discount: '',
                discountAmt: '',
                chargeAmt: '',
                total: '',
                idTaxGroup: 0,
                taxList: [],
                sgst: '',
                cgst: '',
                igst: '',
                sgstAmt: '',
                cgstAmt: '',
                igstAmt: '',
                netTotal: '',
                remarks: '',
                deleteItemsList: [],
                isInwardStatus: false
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.07,
                    flex: 0.7,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPurchase: {
                idCustomer: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
                idGeneralProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "gate pass"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect();
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Sales Return",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    this.setPermissions(permissions);
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idSalesReturn", "disAssemble", "disAssemblePending"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Sales Return",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id, "Sales Return");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.salesObject;
        details.idSalesReturn = id;
        this.setState({ salesObject: details }, () => {
            this.getSalesReturnSelectbyId(this.state.salesObject.idSalesReturn);
        });
    };

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key,
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    usp_Master_PartyAccountSelect = () => {
        this.transactionStockServices.usp_Master_PartyAccountSelectCustomer(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                        partyAddress: x.p_Address
                    }));
                    this.getTaxStructure()
                    let salesObject = this.state.salesObject;
                    salesObject.customerList = dynamicData;
                    this.setState({ salesObject: salesObject }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getTaxStructure()
                }
            }
        });
    }

    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    value: x.idTaxStructure,
                    label: x.taxStructureName,
                }));
                let itemObject = this.state.itemObject;
                itemObject.taxList = res;
                this.setState({
                    itemObject: itemObject
                }, () => {
                    this.getUnit()
                })
            } else {
                this.getUnit()
            }
        });
    }

    getUnit = () => {
        this.accountTransactionServices.getUnit(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    value: x.idUnit,
                    label: x.unitDescription,
                }));
                let itemObject = this.state.itemObject;
                itemObject.unitList = res;
                this.setState({
                    itemObject: itemObject
                }, () => {
                    this.getExtraGatePassSelectForPurchase()
                })
            } else {
                this.getExtraGatePassSelectForPurchase()
            }
        });
    }

    getExtraGatePassSelectForPurchase = () => {
        let request = [this.state.idCompany, this.state.salesObject.updateStatus, this.state.salesObject.idSalesReturn];
        this.transactionStockServices.getExtraGatePassSelectForPurchase(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let salesObject = this.state.salesObject;

                allData = allData.map((x) => ({
                    value: x.idGatePass,
                    label: x.gatePassNo + ' - ' + x.party,
                    partyName: x.partyName,
                    gatepassNo: x.gatePassNo,
                    challanNo: x.challanNo ? x.challanNo : '',
                    challanDate: x.challanDate ? moment(x.challanDate).format('YYYY-MM-DD') : '',
                }));
                salesObject.gatepassList = allData;
                this.setState({
                    salesObject: salesObject,
                    //productObject: productObject
                }, () => {
                    this.getMasterAccountHeadSelect();
                });
            } else {
                this.getMasterAccountHeadSelect();
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let salesObject = this.state.salesObject;
                data = data.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                })).filter(x => x.label === 'SALES RETURN');
                salesObject.accountHeadList = data;
                this.setState({ salesObject: salesObject });
            } else {
            }
        });
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [
            this.state.idCompany,
            label,
            this.state.salesObject.idCustomer
        ];
        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let details = this.state.itemObject;
                details.itemList = data
                this.setState({
                    itemObject: details,
                });
            }
        });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "srNo": window.innerWidth * 0.03,
            "returnNo": window.innerWidth * 0.05,
            "retFrom": window.innerWidth * 0.08,
            "returnDate": window.innerWidth * 0.08,
            "customer": window.innerWidth * 0.15,
            "billNo": window.innerWidth * 0.07,
            "billDate": window.innerWidth * 0.07,
            "gatePassNo": window.innerWidth * 0.06,
            "totalQty": window.innerWidth * 0.06,
            "disAssemble": window.innerWidth * 0.06,
            "disAssemblePending": window.innerWidth * 0.07,
            "storeTransfer": window.innerWidth * 0.06,
            "amount": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "totalWithTax": window.innerWidth * 0.06,
            "extraCharges": window.innerWidth * 0.06,
            "discount": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.1,
            "itemName": window.innerWidth * 0.15,
            "returnQuantity": window.innerWidth * 0.06,
            "disAssembleQty": window.innerWidth * 0.06,
            "disAssemblePendingQty": window.innerWidth * 0.08,
            "rate": window.innerWidth * 0.06,
            "amount": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.06,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.06,
            "cgstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }


    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.transactionStockServices.usp_Transaction_SalesReturnCount(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let count = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (count.toString().length === 1) {
                    formatted = '00' + count;
                } else if (count.toString().length === 2) {
                    formatted = '0' + count;
                } else {
                    formatted = count.toString();
                }
                let salesObject = this.state.salesObject
                salesObject.returnNo = formatted
                salesObject.returnDate = moment(new Date()).format('YYYY-MM-DD');
                this.setState({ salesObject: salesObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getSalesReturnSelectbyId(event.data.idSalesReturn);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.salesObject,
            this.state.validationRulesForPurchase,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
        this.setState({ isModalOpen: false, });
    };

    handleChangeForPurchase = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.salesObject;
        details[name] = value;
        this.setState({ salesObject: details }, () => {
            if (name === 'adjustableAmt') {
                this.finalCalculation()
            }
        });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details }, () => {
            if (name === "returnQuantity" || name === "rate" || name === "discount" || name === "chargeAmt") {
                this.calculatePricing()
            }
        });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.salesObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'salesObject') {
            details[name] = value;
            this.setState({ salesObject: details }, () => {
                if ((name === 'idReturn' || name === 'idCustomer') && this.state.salesObject.idReturn === 2) {
                    this.usp_Transaction_SalesInvoiceSelect_ForSalesReturn()
                } else if (this.state.salesObject.idReturn === 1) {
                    let details = this.state.salesObject;
                    // details.salesList = [];
                    details.idSalesInvoice = 0;
                    this.setState({ salesObject: details });
                }
                if (name === 'idCustomer' && this.state.salesObject.idReturn === 1) {
                    this.getMaster_ItemSelectbyItemType(this.state.itemObject.TypeList.find(x => x.value === this.state.itemObject.idType).label);
                }
                if (name === 'idSalesInvoice') {
                    this.usp_Transaction_SalesInvoiceSelectbyId()
                }
                if (name === 'idGatePass') {
                    let details = this.state.salesObject;
                    details.idCustomer = event.partyName;
                    details.billNo = event.challanNo;
                    details.billDate = event.challanDate;
                    this.setState({ salesObject: details });
                }
            });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details1 }, () => {
                if (name === 'idType') {
                    this.getMaster_ItemSelectbyItemType(this.state.itemObject.TypeList.find(x => x.value === this.state.itemObject.idType).label);
                }
            });
        }
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let details = this.state.salesObject;
        details.idSalesReturn = 0;
        details.updateStatus = 0;
        details.returnDate = moment(new Date()).format('YYYY-MM-DD');
        details.idCustomer = 0;
        details.billNo = '';
        details.billDate = '';
        details.totalQty = '';
        details.totalAmt = '';
        details.extraCharges = '';
        details.totalDiscountAmt = '';
        details.taxAmt = '';
        details.idGatePass = 0;
        details.idGeneralProduct = 0;
        details.finalAmt = '';
        details.totalwithTax = '';
        details.taxableAmt = '';
        this.setState({ salesObject: details, itemRowData: [] });
        this.setState({
            validState: validState
        }, () => {
            this.getExtraGatePassSelectForPurchase()
        });
    }

    usp_Transaction_SalesInvoiceSelect_ForSalesReturn = () => {
        if (this.state.salesObject.idCustomer === 0) {
            return
        }
        let request = [this.state.salesObject.updateStatus, this.state.salesObject.idCustomer, this.state.salesObject.idSalesReturn];
        this.transactionStockServices.usp_Transaction_SalesInvoiceSelect_ForSalesReturn(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let salesObject = this.state.salesObject;
                data = data.map((x) => ({
                    value: x.idSalesInvoice,
                    label: x.invoiceNo,
                }))
                salesObject.salesList = data;
                this.setState({ salesObject: salesObject });
            } else {
            }
        });
    }

    handleOnClick = (event, name) => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.usp_Master_ItemSelectbyID_JobWork(event.data.idItem);
        });
    };

    usp_Master_ItemSelectbyID_JobWork = (id) => {
        let request = {
            idItem: id,
            idVendor: this.state.salesObject.idCustomer,
        }
        if (id !== 0 && this.state.salesObject.idCustomer !== 0) {
            this.transactionStockServices.usp_Master_ItemSelectbyID_JobWork(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent[0];
                    let details = this.state.itemObject;
                    details.idTaxGroup = data.idTaxGroup ? data.idTaxGroup : 0;
                    details.rate = data.finalItemRate ? data.finalItemRate : 0;
                    details.drawingNo = data.drawingNo ? data.drawingNo : "";
                    details.idUnit = this.state.itemObject.unitList.find(x => x.label === data.rateOn) ? this.state.itemObject.unitList.find(x => x.label === data.rateOn).value : 0;
                    this.setState({ itemObject: details }, () => {
                        this.getTaxStructureSelectbyID();
                    })
                }
            });
        }
    }

    getTaxStructureSelectbyID = () => {
        if (this.state.itemObject.idTaxGroup > 0) {
            this.accountTransactionServices.getTaxStructureSelectbyID(this.state.itemObject.idTaxGroup).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.itemObject;
                    data.sgst = res.sgst;
                    data.cgst = res.cgst;
                    data.igst = res.igst;
                    this.setState({ itemObject: data }, () => {
                        this.calculatePricing();
                    });
                }
            });
        }
    }

    calculatePricing = () => {
        if (this.state.itemObject.rate) {
            let itemObject = this.state.itemObject;
            let salesObject = this.state.salesObject;
            itemObject.total = 0;
            itemObject.sgstAmt = 0;
            itemObject.cgstAmt = 0;
            itemObject.igstAmt = 0;
            itemObject.netTotal = 0;
            itemObject.amount = 0
            itemObject.amount = (Number(itemObject.returnQuantity) * Number(itemObject.rate)).toFixed(2);

            let discountPercent = parseFloat(itemObject.discount) || 0;
            let discountAmt = (itemObject.amount * discountPercent) / 100;
            itemObject.discountAmt = discountAmt.toFixed(2);

            let chargeAmt = parseFloat(itemObject.chargeAmt) || 0;
            let total = itemObject.amount - discountAmt + chargeAmt;
            itemObject.total = total.toFixed(2);

            itemObject.sgstAmt = salesObject.idInv === 1 ? Number(((itemObject.total * itemObject.sgst) / 100).toFixed(2)) : 0;
            itemObject.cgstAmt = salesObject.idInv === 1 ? Number(((itemObject.total * itemObject.cgst) / 100).toFixed(2)) : 0;
            itemObject.igstAmt = Number(itemObject.igst) > 0 ? salesObject.idInv === 1 ? 0 : Number(((itemObject.total * itemObject.igst) / 100).toFixed(2)) : 0;
            itemObject.netTotal = (
                Number(itemObject.total) +
                Number(itemObject.sgstAmt) +
                Number(itemObject.cgstAmt) +
                Number(itemObject.igstAmt)
            ).toFixed(2);
            this.setState({ itemObject: itemObject });
        }
    }

    insert = (flag) => {
        let isValid = this.isValidAllFieldsForItem();
        if (!isValid) {
            this.SwalServices.Error("Please fill all required fields.");
            return;
        }
        if (flag === 'Insert') {
            let details = this.state.itemObject;
            let array = this.state.itemRowData;

            const isItemExists = array.some(x => x.idItem === details.idItem);

            if (isItemExists) {
                this.SwalServices.Error("This item is already added.");
                return;
            }
            let itemList = [...this.state.itemRowData];
            let obj = {
                drawingNo: details.drawingNo,
                idType: details.idType,
                materialType: details.TypeList.find(x => x.value === details.idType)?.label,
                idItem: details.idItem,
                itemName: details.itemIdLabel,
                idUnit: details.idUnit,
                itemIdLabel: details.itemIdLabel,
                returnQuantity: Number(details.returnQuantity),
                quantity: details.quantity ? Number(details.quantity) : 0,
                rate: details.rate,
                amount: Number(details.amount),
                total: Number(details.total),
                discount: Number(details.discount),
                discountAmt: Number(details.discountAmt),
                extraCharges: Number(details.chargeAmt),
                idTaxGroup: details.idTaxGroup,
                sgst: details.sgst,
                sgstAmt: Number(details.sgstAmt),
                cgst: details.cgst,
                cgstAmt: Number(details.cgstAmt),
                igst: details.igstAmt > 0 ? details.igst : 0,
                igstAmt: Number(details.igstAmt),
                netTotal: Number(details.netTotal),
                remarks: details.remarks,
                idSalesReturnItems: 0,
                idSalesInvoice: details.idSalesInvoice ? details.idSalesInvoice : 0,
                idSalesInvoiceItems: details.idSalesInvoiceItems ? details.idSalesInvoiceItems : 0,
            }
            itemList.push(obj);
            itemList.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ itemRowData: itemList }, () => {
                this.resetitemObject();
                this.finalCalculation();
            });
        }
        else if (flag === 'Update') {
            let details2 = this.state.itemObject;
            let itemList2 = [...this.state.itemRowData];
            let obj2 = {
                drawingNo: details2.drawingNo,
                idType: details2.idType,
                materialType: details2.TypeList.find(x => x.value === details2.idType)?.label,
                idItem: details2.idItem,
                itemIdLabel: details2.itemIdLabel,
                idUnit: details2.idUnit,
                itemName: details2.itemIdLabel,
                returnQuantity: Number(details2.returnQuantity),
                quantity: details2.quantity ? Number(details2.quantity) : 0,
                rate: Number(details2.rate),
                amount: Number(details2.amount),
                discount: details2.discount ? Number(details2.discount) : 0,
                discountAmt: details2.discountAmt ? Number(details2.discountAmt) : 0,
                extraCharges: details2.chargeAmt ? Number(details2.chargeAmt) : 0,
                total: Number(details2.total),
                idTaxGroup: details2.idTaxGroup,
                sgst: details2.sgst,
                sgstAmt: Number(details2.sgstAmt),
                cgst: details2.cgst,
                cgstAmt: Number(details2.cgstAmt),
                igst: details2.igstAmt > 0 ? details2.igst : 0,
                igstAmt: Number(details2.igstAmt),
                netTotal: Number(details2.netTotal),
                remarks: details2.remarks,
                idSalesReturnItems: details2.idSalesReturnItems ? details2.idSalesReturnItems : 0,
                idSalesInvoice: details2.idSalesInvoice ? details2.idSalesInvoice : 0,
                idSalesInvoiceItems: details2.idSalesInvoiceItems ? details2.idSalesInvoiceItems : 0,
            };
            itemList2[details2.keyId - 1] = obj2;
            itemList2.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ itemRowData: itemList2 }, () => {
                this.resetitemObject();
                this.finalCalculation();
            });
        }
    }

    resetitemObject = () => {
        let details = this.state.itemObject;
        details.drawingNo = '';
        details.idType = 1;
        details.idItem = 0;
        details.itemIdLabel = "";
        details.idUnit = 0;
        details.returnQuantity = 0;
        details.rate = 0;
        details.amount = 0;
        details.discount = 0;
        details.discountAmt = 0;
        details.chargeAmt = 0;
        details.total = 0;
        details.idTaxGroup = 0;
        details.sgst = "";
        details.sgstAmt = "";
        details.cgst = "";
        details.cgstAmt = "";
        details.igst = "";
        details.igstAmt = "";
        details.netTotal = "";
        details.remarks = "";
        details.keyId = "";
        this.setState({ itemObject: details })
    }

    finalCalculation = () => {
        const data = this.state.itemRowData;

        const totals = {
            totalQty: 0,
            totalAmt: 0,
            extraCharges: 0,
            totalDiscountAmt: 0,
            taxAmt: 0,
            taxableAmt: 0,
            totalwithTax: 0,
            finalAmt: 0
        };

        data.forEach(x => {
            totals.totalQty += Number(x.returnQuantity) || 0;
            totals.totalAmt += Number(x.amount) || 0;
            totals.extraCharges += Number(x.extraCharges) || 0;
            totals.totalDiscountAmt += Number(x.discountAmt) || 0;

            totals.taxAmt +=
                (Number(x.sgstAmt) || 0) +
                (Number(x.cgstAmt) || 0) +
                (Number(x.igstAmt) || 0);

            totals.taxableAmt += Number(x.total) || 0;
        });

        totals.totalwithTax = totals.taxableAmt + totals.taxAmt;

        totals.finalAmt = Math.round(
            totals.totalwithTax + (Number(this.state.salesObject.adjustableAmt) || 0)
        );

        this.setState({
            salesObject: {
                ...this.state.salesObject,
                totalQty: totals.totalQty,
                totalQty: totals.totalQty,
                totalAmt: totals.totalAmt.toFixed(2),
                extraCharges: totals.extraCharges.toFixed(2),
                totalDiscountAmt: totals.totalDiscountAmt.toFixed(2),
                taxableAmt: totals.taxableAmt.toFixed(2),
                taxAmt: totals.taxAmt.toFixed(2),
                totalwithTax: totals.totalwithTax.toFixed(2),
                finalAmt: totals.finalAmt
            }
        });
    };

    handleCellClickItemList = (event) => {
        let data = [...this.state.itemRowData];
        let getItemData = data[event.data.keyId - 1];
        let details = this.state.itemObject;
        // details.idWOOrderRecvItems = getItemData.idWOOrderRecvItems;
        details.drawingNo = getItemData.drawingNo
        details.idType = getItemData.idType
        details.idItem = getItemData.idItem
        details.itemIdLabel = getItemData.itemName
        details.idUnit = getItemData.idUnit ? getItemData.idUnit : 12
        details.returnQuantity = getItemData.returnQuantity
        details.quantity = getItemData.quantity
        details.rate = getItemData.rate
        details.amount = getItemData.amount
        details.discount = getItemData.discount
        details.discountAmt = getItemData.discountAmt
        details.chargeAmt = getItemData.extraCharges
        details.total = getItemData.total
        details.idTaxGroup = getItemData.idTaxGroup
        details.sgst = getItemData.sgst
        details.cgst = getItemData.cgst
        details.igst = getItemData.igst
        details.sgstAmt = getItemData.sgstAmt
        details.cgstAmt = getItemData.cgstAmt
        details.igstAmt = getItemData.igstAmt
        details.taxAmt = getItemData.taxAmt
        details.netTotal = getItemData.netTotal
        details.remarks = getItemData.remarks;
        details.keyId = getItemData.keyId;
        details.idSalesInvoiceItems = getItemData.idSalesInvoiceItems ? getItemData.idSalesInvoiceItems : 0;
        details.idSalesInvoice = getItemData.idSalesInvoice ? getItemData.idSalesInvoice : 0;
        details.idSalesReturnItems = getItemData.idSalesReturnItems ? getItemData.idSalesReturnItems : 0;
        details.isInwardStatus = getItemData.isInwardStatus
        this.setState({ itemObject: details }, () => {
            this.getTaxStructureSelectbyID();
        });
    };

    deleteItem = (keyId) => {
        let data = this.state.itemObject;
        let idSalesReturnItems = this.state.itemRowData?.find(item => item.keyId == keyId)?.idSalesReturnItems;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }

        if (idSalesReturnItems > 0) {
            data.deleteItemsList.push(idSalesReturnItems);
        }
        this.setState({ itemObject: { ...data }, itemRowData: filterData }, () => {
            this.resetitemObject();
            this.finalCalculation();
        });
    }

    usp_Transaction_SalesInvoiceSelectbyId = () => {
        if (this.state.salesObject.idSalesInvoice > 0) {
            this.transactionStockServices.usp_Transaction_SalesInvoiceItemsSelectbyId(this.state.salesObject.idSalesInvoice).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    let itemList = [];
                    data.map((details, keyId) => {
                        let obj = {
                            // idWOOrderRecvItems: details.idwoOrderRecvItems,
                            drawingNo: details.itemDrawingNo,
                            idType: this.state.itemObject.TypeList?.find(x => x.label === details.itemType)?.value,
                            materialType: details.itemType ? details.itemType : "",
                            idItem: details.idItem ? details.idItem : 0,
                            itemIdLabel: details.itemName ? details.itemName : "",
                            itemName: details.itemName ? details.itemName : "",
                            quantity: details.quantity ? details.quantity : 0,
                            returnQuantity: 0,
                            rate: details.rate ? details.rate : 0,
                            idSalesInvoiceItems: details.idSalesInvoiceItems ? details.idSalesInvoiceItems : 0,
                            idSalesInvoice: details.idSalesInvoice ? details.idSalesInvoice : 0,
                            // amount: details.amount ? details.amount : 0,
                            // discount: details.discount ? details.discount : 0,
                            // discountAmt: details.discountAmt ? details.discountAmt : 0,
                            // extraCharges: details.extraCharges ? details.extraCharges : 0,
                            // total: details.taxableAmt ? details.taxableAmt : 0,
                            idTaxGroup: details.idTaxGroup ? details.idTaxGroup : 0,
                            // sgst: details.sgst,
                            // cgst: details.cgst,
                            // igst: details.igst,
                            // sgstAmt: details.sgstAmt,
                            // cgstAmt: details.cgstAmt,
                            // igstAmt: details.igstAmt,
                            // taxAmt: details.taxAmt,
                            // netTotal: details.netTotal,
                            // remarks: details.itemRemarks,
                            keyId: keyId + 1,
                        }
                        itemList.push(obj);
                    })
                    this.setState({ itemRowData: itemList });
                }
            });
        }
    }

    submit = () => {
        if (this.isSubmitting) { return; }
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Alert("Please add product items details");
        } else {
            const isValidAllFields = this.isValidAllFieldsForRegister();
            if (isValidAllFields) {
                let data = this.state.salesObject
                let itemObject = this.state.itemObject;
                let request = {
                    idSalesReturn: data.idSalesReturn,
                    updateStatus: data.updateStatus,
                    returnNo: data.returnNo,
                    returnDate: data.returnDate && data.returnDate !== 'Invalid date' ? data.returnDate : null,
                    billNo: data.billNo,
                    billDate: data.billDate && data.billDate !== 'Invalid date' ? data.billDate : null,
                    retFrom: data.returnList.find(x => x.value === data.idReturn)?.label,
                    idGatePass: data.idGatePass,
                    idCustomer: data.idCustomer,
                    idSalesInvoice: data.idSalesInvoice,
                    authorizedBy: data.authorizedBy,
                    totalQty: data.totalQty,
                    totalAmt: data.totalAmt,
                    taxAmt: data.taxAmt,
                    taxableAmt: data.taxableAmt,
                    totalwithTax: data.totalwithTax,
                    extraCharges: data.extraCharges,
                    discount: data.totalDiscountAmt,
                    adjustableAmt: data.adjustableAmt,
                    finalAmt: data.finalAmt,
                    remarks: data.remarks ? data.remarks : "",
                    idCompany: this.state.idCompany,
                    e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: null,
                    idGeneralProduct: data.idGeneralProduct
                };
                request.itemList = [];
                request.deleteItemsList = this.state.itemObject.deleteItemsList;
                let itemList = this.state.itemRowData;
                itemList.map((details) => {
                    let obj = {
                        drawingNo: details.drawingNo,
                        itemType: itemObject.TypeList.find(x => x.value === details.idType)?.label,
                        idItem: details.idItem,
                        quantity: details.quantity,
                        returnQuantity: details.returnQuantity,
                        storeTransferQty: details.storeTransferQty,
                        disAssembleQty: details.disAssembleQty,
                        rate: details.rate,
                        amount: details.amount,
                        discount: details.discount,
                        extraCharges: details.extraCharges,
                        taxableAmt: details.total,
                        idTaxGroup: details.idTaxGroup,
                        sgst: details.sgst,
                        sgstAmt: details.sgstAmt,
                        cgst: details.cgst,
                        cgstAmt: details.cgstAmt,
                        igst: details.igst,
                        igstAmt: details.igstAmt,
                        netTotal: details.netTotal,
                        idSalesInvoiceItems: details.idSalesInvoiceItems ? details.idSalesInvoiceItems : 0,
                        idSalesInvoice: details.idSalesInvoice ? details.idSalesInvoice : 0,
                        idSalesReturnItems: details.idSalesReturnItems ? details.idSalesReturnItems : 0,
                        itemRemarks: details.remarks ? details.remarks : "",
                    }
                    request.itemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitSalesReturn(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.salesObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                }, () => {
                                    this.resetDetailsFields();
                                    this.resetitemObject();
                                    this.procSelectAllRecordsSP();
                                });
                            }
                        }
                    } else {
                        this.SwalServices.Error("Something went wrong. Please contact support.");
                    }
                }).finally(() => { this.isSubmitting = false; this.setState({ isSaving: false }); });
            }
        }
    }

    getSalesReturnSelectbyId = (idSalesReturn) => {
        if (idSalesReturn > 0) {
            this.transactionStockServices.getSalesReturnSelectbyId(idSalesReturn).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let salesObject = this.state.salesObject;
                    salesObject.idSalesReturn = res.idSalesReturn;
                    salesObject.updateStatus = 1;
                    salesObject.returnNo = res.returnNo
                    salesObject.returnDate = res.returnDate ? moment(res.returnDate).format('YYYY-MM-DD') : null;
                    salesObject.billNo = res.billNo
                    salesObject.billDate = res.billDate ? moment(res.billDate).format('YYYY-MM-DD') : '';
                    salesObject.authorizedBy = res.authorizedBy;
                    salesObject.idReturn = salesObject.returnList.find(x => x.label === res.retFrom)?.value;
                    salesObject.idGatePass = res.idGatePass
                    salesObject.idCustomer = res.idCustomer
                    salesObject.idSalesInvoice = res.idSalesInvoice
                    salesObject.e_Date = res.e_Date;
                    salesObject.totalQty = res.totalQty;
                    salesObject.totalAmt = res.totalAmt;
                    salesObject.extraCharges = res.extraCharges;
                    salesObject.totalDiscountAmt = Number(res.discount);
                    salesObject.taxableAmt = res.taxableAmt;
                    salesObject.taxAmt = res.taxAmt;
                    salesObject.totalwithTax = res.totalwithTax;
                    salesObject.finalAmt = res.finalAmt;
                    salesObject.adjustableAmt = res.adjustableAmt;
                    salesObject.idGeneralProduct = res.idGeneralProduct;

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            idSalesReturnItems: details.idSalesReturnItems,
                            drawingNo: details.drawingNo,
                            materialType: details.itemType ? details.itemType : "",
                            idType: this.state.itemObject.TypeList?.find(x => x.label === details.itemType)?.value,
                            idItem: details.idItem ? details.idItem : 0,
                            itemIdLabel: details.itemName ? details.itemName : "",
                            itemName: details.itemName ? details.itemName : "",
                            unit: details.unit ? details.unit : "",
                            quantity: details.quantity ? details.quantity : 0,
                            returnQuantity: details.returnQuantity ? details.returnQuantity : 0,
                            storeTransferQty: details.storeTransferQty ? details.storeTransferQty : 0,
                            disAssembleQty: details.disAssembleQty ? details.disAssembleQty : 0,
                            rate: details.rate ? details.rate : 0,
                            amount: details.amount ? details.amount : 0,
                            discount: details.discount ? details.discount : 0,
                            discountAmt: details.discountAmt ? details.discountAmt : 0,
                            extraCharges: details.extraCharges ? details.extraCharges : 0,
                            total: details.taxableAmt ? details.taxableAmt : 0,
                            idTaxGroup: details.idTaxGroup ? details.idTaxGroup : 0,
                            sgst: details.sgst,
                            cgst: details.cgst,
                            igst: details.igst,
                            sgstAmt: details.sgstAmt,
                            cgstAmt: details.cgstAmt,
                            igstAmt: details.igstAmt,
                            taxAmt: details.taxAmt,
                            netTotal: details.netTotal,
                            remarks: details.itemRemarks,
                            keyId: keyId + 1,
                            isInwardStatus: details.isInwardStatus
                        }
                        itemList.push(obj);
                    })
                    this.setState({ salesObject: salesObject, itemRowData: itemList, isModalOpen: true, globalUserID: res.modifiedBy }, () => {
                        this.finalCalculation()
                        this.getExtraGatePassSelectForPurchase()
                    });
                }
            });
        }
    }

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idSalesReturn, "Sales Return");
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <SalesReturnPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            salesObject={this.state.salesObject}
                            itemObject={this.state.itemObject}
                            handleChangeForPurchase={this.handleChangeForPurchase.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            handleOnClick={this.handleOnClick.bind(this)}
                            insert={this.insert.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            clearItemObject={this.resetitemObject.bind(this)}
                            delete={this.deleteItem.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Sales return</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    // onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onCellClicked={this.handleCellClick}
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemObject.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </div>
        )
    }
}
